import React, { useState } from 'react';

import { Card, Alert } from 'antd';

import { AssistanceSection } from './AssistanceSection';
import { SectionCard } from './SectionCard';
import { SecurityCodeSection } from './SecurityCodeSection';
import { ShipmentHeader } from './ShipmentHeader';
import { TelemetrySection } from './TelemetrySection';
import { useShipmentInspection } from '../hooks/useShipmentInspection';

export const ShipmentCard = ({
  shipment,
  onStartInspection,
  isOpen,
  isCollapse = false,
  isExpanded,
  onToggle,
  isDisabled = false,
  ...props
}: {
  shipment: any;
  onStartInspection: (shipment: any) => void;
  isOpen?: boolean;
  [key: string]: any;
  isCollapse?: boolean;
  isExpanded?: boolean;
  onToggle?: () => void;
  isDisabled?: boolean;
}) => {
  const [openCards, setOpenCards] = useState<boolean>(false);

  const isCardExpanded = isExpanded !== undefined ? isExpanded : openCards;

  const {
    shipmentWithInspection,
    telemetryProps,
    securityCodeProps,
    assistanceProps,
  } = useShipmentInspection({
    shipment,
    enabled: isCardExpanded,
  });

  const handleToggle = () => {
    if (onToggle) {
      onToggle();
    } else {
      setOpenCards(!openCards);
    }
  };

  return (
    <Card
      {...props}
      style={{
        marginBottom: 16,
        borderColor: '#CCD8D6',
        boxShadow: '0rem .125rem .25rem 0rem #0000001A',
        opacity: isDisabled ? 0.5 : 1,
        pointerEvents: isDisabled ? 'none' : 'auto',
        transition: 'opacity 0.3s ease',
      }}
      styles={{
        body: {
          padding: '.75rem',
        },
      }}
    >
      <ShipmentHeader
        lpui={shipment?.lp_ui}
        carrierTrackingCode={shipment?.carrier?.tracking_code}
        inspectionInProgress={shipmentWithInspection?.inspection_in_progress}
        isCollapsible={isCollapse}
        isExpanded={isCardExpanded}
        onToggle={handleToggle}
        isDisabled={isDisabled}
      />

      {isCardExpanded || !isCollapse ? (
        <>
          {shipmentWithInspection.inspection_in_progress && (
            <Alert
              message="This BOX is already being inspected."
              type="error"
              showIcon
              style={{
                fontSize: '1rem',
                fontWeight: 400,
                lineHeight: '135%',
                marginBottom: '16px',
              }}
            />
          )}

          {/* Telemetry Section */}
          <SectionCard>
            <TelemetrySection {...telemetryProps} />
          </SectionCard>

          {/* Security Code Section */}
          <SectionCard>
            <SecurityCodeSection {...securityCodeProps} />
          </SectionCard>

          {/* Assistance Section */}
          <SectionCard>
            <AssistanceSection
              {...assistanceProps}
              onRemoteControl={() => onStartInspection(shipmentWithInspection)}
            />
          </SectionCard>
        </>
      ) : null}
    </Card>
  );
};
